import axios from 'axios'
import store from '@/store'
import { UserGetters } from '@/store/modules/user/types'
import { IS_PROD } from '../../config/base'

class SiriusTrackClass {
  private timer = 0
  private controller = ''
  private action = ''

  start({ action, controller }: { action: string; controller: string }) {
    this.timer = new Date().getTime()
    this.controller = controller
    this.action = action
  }

  finish() {
    if (!this.action || !this.controller || !IS_PROD) return
    const payload = {
      controller: this.controller,
      action: this.action,
      project: store.getters['getPlatform'],
      userid: (store.getters['user/getUserId'] as UserGetters['getUserId'])(
        store.getters['getProjectId']
      ),
      time: new Date().getTime() - this.timer,
    }
    const customAxios = axios.create()
    customAxios.post(
      `https://statistics.fppressa.ru/admin_track/sirius/`,
      payload,
      {
        headers: {
          'Content-Type': 'text/plain',
        },
      }
    )
    this.controller = ''
    this.action = ''
  }
}
const SiriusTrack = new SiriusTrackClass()
export default SiriusTrack
